import {getFunctions, httpsCallable} from "firebase/functions";
import {Chat} from "../lib/types";
import {func} from "prop-types";

export const FunctionCaller = () => {
  return (
    <div>
      <h1>Function Caller</h1>
      <div>
        <input type="text" className={"border border-gray-1 p-2"} onKeyUp={
          async (e) => {
            if (e.key === "Enter") {
              const functions = getFunctions();
              const functionName = httpsCallable(functions, e.currentTarget.value);
              await functionName({});
            }
          }
        }/>
      </div>
    </div>

  )
}